var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "umesr-rows-list" },
    _vm._l(_vm.value, function(item, index) {
      return _c(
        "div",
        {
          key: `umesr-rows-list-${index}`,
          class: `umesr-rows-list__item umesr-rows-list__item__index-${index}`
        },
        [
          _c(
            "custom-callout",
            {
              staticClass: "mb-3 callout",
              attrs: {
                "border-color": _vm.getColor(item.statuCode),
                controlled: true,
                opened: item.isOpen
              },
              on: {
                "click:open": function($event) {
                  return _vm.onOpenDetails(_vm.value[index], index)
                }
              },
              scopedSlots: _vm._u(
                [
                  {
                    key: "edition",
                    fn: function() {
                      return [_c("additional-info", { attrs: { value: item } })]
                    },
                    proxy: true
                  }
                ],
                null,
                true
              )
            },
            [
              _c("row-standard", {
                attrs: { index: index, value: item },
                on: { "on-delete": _vm.onDeleteHandler }
              })
            ],
            1
          )
        ],
        1
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }